import angular from 'angular';
import uiRouter from 'angular-ui-router';
import userDetailsComponent from './user-details.component';

let userDetailsModule = angular.module('app.containers.user-details', [

])

.config(($stateProvider) => {
  "ngInject";
  $stateProvider
    .state('userDetails', {
      url: '/users/:userId',
      template: '<user-details></user-details>'
    });
})

.component('userDetails', userDetailsComponent);

export default userDetailsModule;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/user-details/user-details.js
 **/